//////////////////////////////

module.exports = (type) => {
    var schema = {
        id: {
            type: type.INTEGER,
            primaryKey: true,
            autoIncrement: true,
        },
        label: {
            type: type.STRING(64),
            allowNull: false,
        },
        created: {
            type: type.DATE,
            allowNull: false,
            defaultValue: type.NOW,
        },
        customer_id: {
            type: type.INTEGER,
            allowNull: false,
            references: {
                model       : 'customers',
                key         : 'id',
                constraints : true,
                store_name  : 'customer',
            }
        },
        config: {
            type: type.JSONB,
            allowNull: false,
            defaultValue: {},
        },
    };

    return schema;
}

